module.exports = __webpack_public_path__ + "img/nginxwise4.17b0f85e.png";